import { getWelcomeExperience } from '@library/api-onboarding-welcome'
import type {
  WelcomeDiscountBannerData,
  WelcomeDiscountBannerDetail,
  WelcomeDiscountBannerState,
  WelcomeDiscountBannerTitle,
} from '@library/onboarding-components'
import useSWR from 'swr'

export type WelcomeHeaderData = {
  title: string
  subtitle: string
}

export type {
  WelcomeDiscountBannerData,
  WelcomeDiscountBannerDetail,
  WelcomeDiscountBannerState,
  WelcomeDiscountBannerTitle,
}

export type WelcomeExperience = {
  header: WelcomeHeaderData
  discountBanner: WelcomeDiscountBannerData | null
}

export const WELCOME_EXPERIENCE_API_KEY = 'api/activate/onboarding/welcome/v1'

const EMPTY_HEADER: WelcomeHeaderData = {
  title: '',
  subtitle: '',
}

export const useWelcomeExperience = () => {
  const { data, error } = useSWR(WELCOME_EXPERIENCE_API_KEY, getWelcomeExperience)

  return {
    header: {
      title: data?.header?.title ?? EMPTY_HEADER.title,
      subtitle: data?.header?.sub_title ?? EMPTY_HEADER.subtitle,
    },
    discountBanner:
      data?.discount_banner === null || !data?.discount_banner
        ? null
        : {
            title: data.discount_banner.title,
            discountDetails: data.discount_banner.discount_details.map((detail) => ({
              state: detail.state,
              title: {
                discount: detail.title.discount,
                supportingText: detail.title.supporting_text,
              },
              subtitle: detail.sub_title,
            })),
          },

    error,
  }
}
